import React, { useState } from "react";
import logo from "../../assets/INVESTYCOONS LOGO.png";
import { FaWhatsapp } from "react-icons/fa";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";


const Nav = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [activeSubDropdown, setActiveSubDropdown] = useState(null);


  const projects = {
    project1: [
      { text: "Lake View Farms", link: "/lake-view-farms" },
      { text: "Ace AcreVille", link: "/ace-acreville" },
      { text: "ATS Province D Olympia", link: "/ats-province-d-olmpia" },
      { text: "Godrej Indore", link: "/godrej-indore" },
      { text: "Lodha Goa One", link: "/lodha-goa" },
      { text: "Jewar Green Residency", link: "/residential-plot" }
    ],
    project2: [
      { text: "Godrej Majesty", link: "/godrej-sector-12" },
      { text: "Gaur Aspire Centurian Park", link: "/gaur-aspire-centurian-park" },
      { text: "Sobha Reality", link: "/sobha-reality" },
      { text: "Prestige City", link: "/prestige-city" },
      { text: "Godrej Reverine", link: "/godrej-reverine" },
      { text: "SKA Estate", link: "/ska-estate" },
      { text: "Purvanchal Sunbliss", link: "/purvanchal-sunbliss" },
      { text: "ATS Pious Orchards", link: "/ats-pious-orchards" },
      { text: "ATS Picturesque Reprieves", link: "/ats-picturesque-reprieves" }
    ],
    project3: [
      { text: "Bhutani City Center", link: "/bhutani-city-center" },
      { text: "Bhutani Noida Extension", link: "/bhutani-noida-extension" },
      { text: "Bhutani Cyberthum", link: "/bhutani-cyberthum" },
      { text: "Bhutani Filmcity", link: "/bhutani-film-city" }
    ]
  }


  return (
    <>
      <nav className="bg-white shadow-lg fixed top-0 left-0 w-full z-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex justify-between items-center h-16">
            <a href="/" className="flex items-center">
              <img src={logo} alt="InvestyCoons Logo" className="h-14 w-auto" />
            </a>
            <div className="hidden md:flex space-x-8">
              <a href="/" className="text-gray-900 font-medium hover:text-green-600 transition">Home</a>
              <div className="relative group">
                <a
                  href="/"
                  className="text-md font-medium hover:text-green-600 transition duration-300"
                >
                  Projects
                </a>
                <div className="absolute left-0 hidden group-hover:block bg-white shadow-lg p-3 rounded-lg w-52 transition duration-300 opacity-0 group-hover:opacity-100">
                  <div
                    className="relative group/project1"
                    onMouseEnter={() => setActiveDropdown("project1")}
                    onMouseLeave={() => setActiveDropdown(null)}
                  >
                    <h3 className="text-sm font-semibold cursor-pointer hover:text-green-600 p-2 rounded transition duration-300">
                      Plots
                    </h3>
                    <div
                      className={`absolute left-full top-0 bg-white shadow-lg p-2 rounded w-48 transition duration-300 ${activeDropdown === "project1" ? "opacity-100 block" : "opacity-0 hidden"
                        }`}
                    >
                      <a href="/lake-view-farms" className="block px-4 py-2 hover:bg-green-600 hover:text-white rounded transition duration-300">
                        Lake View Farms
                      </a>
                      <a href="/ace-acreville" className="block px-4 py-2 hover:bg-green-600 hover:text-white rounded transition duration-300">
                        Ace AcreVille
                      </a>
                      <a href="/ats-province-d-olmpia" className="block px-4 py-2 hover:bg-green-600 hover:text-white rounded transition duration-300">
                        ATS Province D Olmpia
                      </a>
                      <a href="/godrej-indore" className="block px-4 py-2 hover:bg-green-600 hover:text-white rounded transition duration-300">
                        Godrej Indore
                      </a>
                      <a href="/lodha-goa" className="block px-4 py-2 hover:bg-green-600 hover:text-white rounded transition duration-300">
                        Lodha Goa One
                      </a>
                      <a href="/residential-plot" className="block px-4 py-2 hover:bg-green-600 hover:text-white rounded transition duration-300">
                        Jewar Green Residency
                      </a>
                    </div>
                  </div>
                  <div
                    className="relative group/project2 mt-2"
                    onMouseEnter={() => setActiveDropdown("project2")}
                    onMouseLeave={() => setActiveDropdown(null)}
                  >
                    <h3 className="text-sm font-semibold cursor-pointer hover:text-green-600 p-2 rounded transition duration-300">
                      Residential
                    </h3>
                    <div
                      className={`absolute left-full top-0 bg-white shadow-lg p-2 rounded w-48 transition duration-300 ${activeDropdown === "project2" ? "opacity-100 block" : "opacity-0 hidden"
                        }`}
                    >
                      <a href="/godrej-sector-12" className="block px-4 py-2 hover:bg-green-600 hover:text-white rounded transition duration-300">
                        Godrej Majesty
                      </a>
                      <a href="/gaur-aspire-centurian-park" className="block px-4 py-2 hover:bg-green-600 hover:text-white rounded transition duration-300">
                        Gaur Aspire Centurian Park
                      </a>
                      <a href="/sobha-reality" className="block px-4 py-2 hover:bg-green-600 hover:text-white rounded transition duration-300">
                        Sobha Reality
                      </a>
                      <a href="/prestige-city" className="block px-4 py-2 hover:bg-green-600 hover:text-white rounded transition duration-300">
                        Prestige City
                      </a>
                      <a href="/godrej-reverine" className="block px-4 py-2 hover:bg-green-600 hover:text-white rounded transition duration-300">
                        Godrej Reverine
                      </a>
                      <a href="/ska-estate" className="block px-4 py-2 hover:bg-green-600 hover:text-white rounded transition duration-300">
                        SKA Estate
                      </a>
                      <a href="/purvanchal-sunbliss" className="block px-4 py-2 hover:bg-green-600 hover:text-white rounded transition duration-300">
                        Purvanchal Sunbliss
                      </a>
                      <a href="/ats-pious-orchards" className="block px-4 py-2 hover:bg-green-600 hover:text-white rounded transition duration-300">
                        ATS Pious Orchards
                      </a>
                      <a href="/ats-picturesque-reprieves" className="block px-4 py-2 hover:bg-green-600 hover:text-white rounded transition duration-300">
                        ATS Picturesque Reprieves
                      </a>
                    </div>
                  </div>
                  <div
                    className="relative group/project2 mt-2"
                    onMouseEnter={() => setActiveDropdown("project3")}
                    onMouseLeave={() => setActiveDropdown(null)}
                  >
                    <h3 className="text-sm font-semibold cursor-pointer hover:text-green-600 p-2 rounded transition duration-300">
                      Commercial
                    </h3>
                    <div
                      className={`absolute left-full top-0 bg-white shadow-lg p-2 rounded w-48 transition duration-300 ${activeDropdown === "project3" ? "opacity-100 block" : "opacity-0 hidden"
                        }`}
                    >
                      <a href="/bhutani-city-center" className="block px-4 py-2 hover:bg-green-600 hover:text-white rounded transition duration-300">
                        Bhutani City Center
                      </a>
                      <a href="/bhutani-noida-extension" className="block px-4 py-2 hover:bg-green-600 hover:text-white rounded transition duration-300">
                        Bhutani Noida Extension
                      </a>
                      <a href="/bhutani-cyberthum" className="block px-4 py-2 hover:bg-green-600 hover:text-white rounded transition duration-300">
                        Bhutani Cyberthum
                      </a>
                      <a href="/bhutani-film-city" className="block px-4 py-2 hover:bg-green-600 hover:text-white rounded transition duration-300">
                        Bhutani Filmcity
                      </a>
                    </div>
                  </div>
                </div>

              </div>
              <a href="/about" className="text-gray-900 font-medium hover:text-green-600 transition">About</a>
              <a href="/connect" className="text-gray-900 font-medium hover:text-green-600 transition">Connect</a>
            </div>
            <div className="hidden md:flex">
              <a href="https://wa.me/9311051597" target="_blank" rel="noopener noreferrer" className="flex bg-green-500 rounded-full items-center space-x-2 py-2 px-4 text-white hover:bg-green-600 transition">
                <FaWhatsapp className="text-xl" />
                <span>Enquire</span>
              </a>
            </div>
            <button className="md:hidden text-gray-800" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                {isMobileMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7" />
                )}
              </svg>
            </button>
          </div>
          {isMobileMenuOpen && (
            <div className="md:hidden absolute top-16 left-0 w-full bg-white text-gray-900 shadow-lg p-4 ">
              <a href="/" className="block text-md font-medium py-2 hover:text-indigo-500 transition-all">Home</a>
              <div className="w-full">
                <button
                  onClick={() => setActiveDropdown(activeDropdown === "projects" ? null : "projects")}
                  className="flex items-center justify-between w-full text-left text-md font-medium py-2 hover:text-green-600 transition-all"
                >
                  Projects
                  {activeDropdown === "projects" ? (
                    <FaChevronDown className="w-4 h-4 transition-transform rotate-180" />
                  ) : (
                    <FaChevronRight className="w-4 h-4 transition-transform" />
                  )}
                </button>
                {activeDropdown === "projects" && (
                  <div className="mt-2 bg-white p-3 rounded shadow-md">
                    <button
                      onClick={() => setActiveSubDropdown(activeSubDropdown === "project1" ? null : "project1")}
                      className="flex items-center justify-between w-full text-left text-sm font-bold py-2 hover:text-green-600"
                    >
                      Plots
                      {activeSubDropdown === "project1" ? (
                        <FaChevronDown className="w-4 h-4 transition-transform rotate-180" />
                      ) : (
                        <FaChevronRight className="w-4 h-4 transition-transform" />
                      )}
                    </button>
                    {activeSubDropdown === "project1" && (
                      <ul className="mt-1 space-y-2 pl-4 border-l-2 border-green-500">
                        {projects.project1.map((item, idx) => (
                          <li key={idx} className="hover:bg-gray-100 px-2 py-1 rounded">
                            <a href={item.link} className="text-sm text-gray-700 hover:text-green-600">{item.text}</a>
                          </li>
                        ))}
                      </ul>
                    )}
                    <button
                      onClick={() => setActiveSubDropdown(activeSubDropdown === "project2" ? null : "project2")}
                      className="flex items-center justify-between w-full text-left text-sm font-bold py-2 hover:text-green-600 mt-2"
                    >
                      Residential
                      {activeSubDropdown === "project2" ? (
                        <FaChevronDown className="w-4 h-4 transition-transform rotate-180" />
                      ) : (
                        <FaChevronRight className="w-4 h-4 transition-transform" />
                      )}
                    </button>
                    {activeSubDropdown === "project2" && (
                      <ul className="mt-1 space-y-2 pl-4 border-l-2 border-green-500">
                        {projects.project3.map((item, idx) => (
                          <li key={idx} className="hover:bg-gray-100 px-2 py-1 rounded">
                            <a href={item.link} className="text-sm text-gray-700 hover:text-green-600">{item.text}</a>
                          </li>
                        ))}
                      </ul>
                    )}
                    <button
                      onClick={() => setActiveSubDropdown(activeSubDropdown === "project3" ? null : "project3")}
                      className="flex items-center justify-between w-full text-left text-sm font-bold py-2 hover:text-green-600 mt-2"
                    >
                      Commercial
                      {activeSubDropdown === "project3" ? (
                        <FaChevronDown className="w-4 h-4 transition-transform rotate-180" />
                      ) : (
                        <FaChevronRight className="w-4 h-4 transition-transform" />
                      )}
                    </button>

                    {activeSubDropdown === "project3" && (
                      <ul className="mt-1 space-y-2 pl-4 border-l-2 border-green-500">
                        {projects.project2.map((item, idx) => (
                          <li key={idx} className="hover:bg-gray-100 px-2 py-1 rounded">
                            <a href={item.link} className="text-sm text-gray-700 hover:text-green-600">{item.text}</a>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                )}
              </div>
              <a href="/about" className="block text-md font-medium py-2 hover:text-green-600 transition-all">About</a>
              <a href="/connect" className="block text-md font-medium py-2 hover:text-green-600 transition-all">Connect</a>
            </div>
          )}
        </div>
      </nav>
      <a
        href="https://wa.me/9311051597"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 bg-green-500 p-3 rounded-full shadow-lg hover:bg-green-600 transition transform hover:scale-105 z-50"
      ><FaWhatsapp className="text-white text-3xl" />
      </a>
    </>
  )
}
export default Nav;